export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4776.a4dba2e6.jpg";